// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2wusM","gfeWrapper":"CalendarEvent_gfeWrapper__31EvO"};